<h2 mat-dialog-title>
	<span class="color-dot" [style.background]="data.color"></span>
	<!-- Le nom mène à SA fiche : vraie balise <a>, donc ctrl/shift+clic = nouvel onglet
	     (et le dialogue reste ouvert ; seul le clic simple navigue et le referme). -->
	<a class="sheet-link" [routerLink]="['/hr/employee', data.id_employee]" (click)="onSheetLink($event)"
		matTooltip="Ouvrir la fiche employé">{{ data.name }}</a>
</h2>

<mat-dialog-content>
	<div class="week-nav">
		<button mat-icon-button aria-label="Semaine précédente" (click)="onShiftWeek(-1)">
			<mat-icon>chevron_left</mat-icon>
		</button>
		<span class="week-label">{{ weekLabel }}</span>
		<button mat-icon-button aria-label="Semaine suivante" (click)="onShiftWeek(1)">
			<mat-icon>chevron_right</mat-icon>
		</button>
		<button mat-stroked-button (click)="onToday()">Cette semaine</button>
	</div>

	<div class="days">
		@for (day of days; track day.label) {
			<div class="day" [class.off]="day.entries.length === 0">
				<span class="day-label">{{ day.label }}</span>
				<span class="entries">
					@if (day.entries.length === 0) {
						<span class="rest">repos</span>
					}
					@for (e of day.entries; track $index) {
						<span class="entry" [class.here]="e.here" [title]="e.place">
							{{ e.time }}&nbsp;<span class="place">{{ e.place }}</span>
						</span>
					}
				</span>
			</div>
		}
	</div>

	<div class="total">Total semaine : <strong>{{ totalLabel }}</strong></div>
	<div class="hint">Horaires types de tous les services (les congés et exceptions se lisent sur le Planning).</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<a mat-stroked-button class="sheet-button" [routerLink]="['/hr/employee', data.id_employee]" (click)="onSheetLink($event)">
		<mat-icon>badge</mat-icon>&nbsp;Fiche employé
	</a>
	<span class="spacer"></span>
	<button mat-flat-button color="primary" mat-dialog-close>Fermer</button>
</mat-dialog-actions>
